export function getProtectedRoute({ isAuthenticated, pathname }) {
  if (isAuthenticated) return null;
  const from = typeof pathname === "string" && pathname.startsWith("/") ? pathname : "/";
  return { pathname: "/login", state: { from } };
}

